//import Libraries
import React from 'react';

//import Components
import Map from '../../../../components/Map/Map';
import Button from '../../../../components/Button/Button';

//import Style classes
import './LocationCard.css';

const locationCard = (props) => {
    const staticText= {
        tel: {"en":"TEL", "ko":"전화번호"},
        fax: {"en":"FAX", "ko":"팩스"}
    }
    let tempTelLink;
    if(props.data.telephone.indexOf("~") !== -1){
        tempTelLink = props.data.telephone.slice(0, props.data.telephone.indexOf("~"));
        if(tempTelLink.indexOf("0") === 0) tempTelLink = tempTelLink.slice(1, tempTelLink.length);
    } else{
        tempTelLink = props.data.telephone;
        if(tempTelLink.indexOf("0") === 0) tempTelLink = tempTelLink.slice(1, tempTelLink.length);
    }
    const telLink = "+82"+tempTelLink.split("-").join("");
    return (
        <div className="LocationCard">
            <div className="MapWrapper">
                <Map data={props.data}></Map>
            </div>
            <div className="Content">
                <h2>{props.data.name[props.lang]}</h2>
                <p>{props.data.address[props.lang]}</p>
                <p><strong>{staticText.tel[props.lang]} : </strong><a href={telLink}>{props.data.telephone}</a></p>
                <p><strong>{staticText.fax[props.lang]} : </strong>{props.data.fax}</p>
                <Button name={{"en": "Contact", "ko": "연락하기"}} language={props.lang} style={{float: "right"}} link="community#Contact-01"/>
            </div>
        </div>
    )
}

export default locationCard;


// WEBPACK FOOTER //
// ./src/pages/About/Locations/LocationCard/LocationCard.js